import React from 'react'
import { IonToast } from '@ionic/react'
import './index.css'

export interface ToastProps {
    isOpen?: boolean
    message?: string
    duration?: number
    onClose?: () => void
    color?: 'error' | 'normal' | 'success'
    position?: 'top' | 'middle' | 'bottom'
}
const Toast: React.FC<ToastProps> = (props) => {
    const {
        isOpen = false,
        message,
        duration = 1000,
        onClose,
        color = 'normal',
        position = 'middle',
    } = props
    return (
        <IonToast
            cssClass={`toast ${color}`}
            isOpen={isOpen && !!message}
            message={message}
            duration={duration}
            position={position}
            onDidDismiss={onClose}
        />
    )
}

export default Toast
